import { useState, useEffect } from 'react';
import './App.scss';
import RouterMaster from './router/routerMaster'
import useStore from './store/useStore'
import moment from 'moment'
import { userModule } from './modules/user';
import { SocketModule } from './modules/socket';
import { StorageModule } from './modules/storage';
import { ProcessModule } from './modules/process';
import { message } from 'antd';
import NavBar from './components/navbar';
import BottomBar from './components/bottombar';
import GanttSchedule from './components/ganttSchedule/index'
import TagMetaMenu from './components/memos/index'
import SelectTag from './components/memos/selectTag'

moment.locale('zh-cn', {
  months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
  monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
  weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
  weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
  weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: 'YYYY年MM月DD日',
    LLL: 'YYYY年MM月DD日Ah点mm分',
    LLLL: 'YYYY年MM月DD日ddddAh点mm分',
    l: 'YYYY-M-D',
    ll: 'YYYY年M月D日',
    lll: 'YYYY年M月D日 HH:mm',
    llll: 'YYYY年M月D日dddd HH:mm'
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function (hour: any, meridiem: any) {
    if (hour === 12) {
      hour = 0;
    }
    if (meridiem === '凌晨' || meridiem === '早上' ||
      meridiem === '上午') {
      return hour;
    } else if (meridiem === '下午' || meridiem === '晚上') {
      return hour + 12;
    } else {
      // '中午'
      return hour >= 11 ? hour : hour + 12;
    }
  },
  meridiem: function (hour, minute, isLower) {
    const hm = hour * 100 + minute;
    if (hm < 600) {
      return '凌晨';
    } else if (hm < 900) {
      return '早上';
    } else if (hm < 1130) {
      return '上午';
    } else if (hm < 1230) {
      return '中午';
    } else if (hm < 1800) {
      return '下午';
    } else {
      return '晚上';
    }
  },
  calendar: {
    sameDay: '[今天]LT',
    nextDay: '[明天]LT',
    nextWeek: '[下]ddddLT',
    lastDay: '[昨天]LT',
    lastWeek: '[上]ddddLT',
    sameElse: 'L'
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
  // @ts-ignore
  ordinal: function (number, period) {
    switch (period) {
      case 'd':
      case 'D':
      case 'DDD':
        return number + '日';
      case 'M':
        return number + '月';
      case 'w':
      case 'W':
        return number + '周';
      default:
        return number;
    }
  },
  relativeTime: {
    future: '%s内',
    past: '%s前',
    s: '几秒',
    ss: '%d秒',
    m: '1分钟',
    mm: '%d分钟',
    h: '1小时',
    hh: '%d小时',
    d: '1天',
    dd: '%d天',
    M: '1个月',
    MM: '%d个月',
    y: '1年',
    yy: '%d年'
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  }
})

interface State {
  socketServer: any;
  userInfo: any;
  timer: any;
  count: number;
  ismain: boolean;
}

function App() {
  const [state, setState] = useState<State>({
    socketServer: null,
    userInfo: {},
    timer: null,
    count: 0,
    ismain: true,
  });
  const { store, dispatch } = useStore()
  message.config({
    duration: 5,
    maxCount: 3,
  });
  useEffect(() => {
    // init()
    // @ts-ignore
    window.init = init
    init()
    console.log(StorageModule.getUser().token)
    // @ts-ignore
    window.appdispatch = dispatch

    return () => {
      clearInterval(state.timer)
    }
  }, [])
  const closeclick = (e: any) => {
    const roll = (item: any): boolean => {
      if (item.getAttribute("class") === 'x6-graph-svg' || item.getAttribute("class") == 'CLOSESHOWALL') {
        return true;
      } else if (item.parentElement && item.parentElement.tagName !== 'BODY') {
        return roll(item.parentElement)
      } else {
        return false;
      }
    }
    const isSvg = roll(e.target);
    if (isSvg) {
      dispatch({
        type: 'SET_CLOSESHOWALL',
        data: false
      });
      dispatch({
        type: 'SET_CHATID',
        data: ''
      });
      dispatch({
        type: 'SET_CHATDISCUSSIONID',
        data: ''
      });
    }
  }
  useEffect(() => {
    //监听全局公共组件图标
    window.addEventListener('click', closeclick);
    return () => {
      window.removeEventListener('click', closeclick);
    }
  }, []);
  useEffect(() => {
    if (StorageModule.getUser().token) {
      console.log()
      let url = `${process.env.REACT_APP_WS}/websocket?Authorization=${StorageModule.getUser().token}`;


      state.socketServer = new SocketModule('消息任务', url, {
        onOpen: () => {
        },
        useReconnect: true
      } as any);
      SocketModule.setMainSocket(state.socketServer);
    }
  }, [StorageModule.getUser().token])

  // const getHost = () => {
  //   if (window.location.host.includes('localhost')) {
  //     return '123.124.91.21:9080'
  //   } else {
  //     return window.location.host
  //   }
  // }

  const getPath = () => {
    return '/things_memo_dev/websocket'
  }
  const init = () => {
    let token = StorageModule.getUser().token
    const isLogin = window.location.href.indexOf('login') > -1;
    state.ismain = isLogin
    setState({ ...state });
    if (!isLogin) {
      if (token) {
        state.userInfo = StorageModule.getUser().user
        userModule.updateUser({
          token,
          user: state.userInfo
        })
        setState({ ...state })
      }
    }
    setState({ ...state })
    window.addEventListener('hashchange', (e: any) => {
      const isLogin = e.newURL.indexOf('login') > -1;
      state.ismain = isLogin
      setState({ ...state });
    })

    // 初始化的时候清楚执行中的暂存数据
    ProcessModule.clearExecuteList();
    setState({ ...state })
  }
  return (
    <div className="App">
      {window.location.href.indexOf('auth') > -1 ? <>
        <RouterMaster></RouterMaster>
      </> :
        <> {
          !state.ismain ?
            <NavBar history={''} /> : <></>
        }
          <RouterMaster></RouterMaster>
          {/* <GanttSchedule /> */}
          {
            !state.ismain ?
              <BottomBar history={''} /> : <></>
          }
          <TagMetaMenu styleCss={{ width: '160px' }} visible={store.showLable} onClose={() => {
            dispatch({
              type: 'SET_SHOWLABLE',
              data: false
            });
          }} ></TagMetaMenu>
          <SelectTag   /> 
        </>}
    </div>
  );
}

export default App;
